import React, { useState } from "react";
import { IconButton } from "@evergis/ui";
import { usePlayTicks } from "../hooks";

export default () => {
  const [isPlayed, changePlayed] = useState(false);
  const [play, pause] = usePlayTicks();

  return isPlayed ? (
    <IconButton
      kind="pause"
      onClick={() => {
        pause();
        changePlayed(false);
      }}
    />
  ) : (
    <IconButton
      kind="play"
      onClick={() => {
        changePlayed(true);
        play();
      }}
    />
  );
};
